var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M448 256c0-106-86-192-192-192v384c106 0 192-86 192-192zM0 256a256 256 0 11512 0 256 256 0 11-512 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }